module.exports = __webpack_public_path__ + "static/media/us-map.915ccbd5.svg";